// File Metadata:
// Filename: RecentDecisions.js
// Version: 1.00
// Created: 2025-03-23 01:04:46
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { List, ListItem, ListItemText, Chip, Box } from '@mui/material'
import { format } from 'date-fns'

const RecentDecisions = ({ receptions }) => {
    const recentDecisions = Object.values(receptions?.entities || {})
        .filter(r => r.approvalHistory?.length)
        .sort((a, b) => {
            const aDate = a.approvalHistory[a.approvalHistory.length - 1].timestamp
            const bDate = b.approvalHistory[b.approvalHistory.length - 1].timestamp
            return new Date(bDate) - new Date(aDate)
        })
        .slice(0, 5)

    return (
        <List>
            {recentDecisions.map(reception => {
                const latestDecision = reception.approvalHistory[reception.approvalHistory.length - 1]
                return (
                    <ListItem key={reception.id} divider>
                        <ListItemText
                            primary={`${reception.vendorName} - TU ${reception.tourNumber}`}
                            secondary={format(new Date(latestDecision.timestamp), 'dd-MM-yyyy HH:mm')}
                        />
                        <Box>
                            <Chip
                                label={latestDecision.status.replace('_', ' ')}
                                color={
                                    latestDecision.status === 'APPROVED' ? 'success' :
                                    latestDecision.status === 'REJECTED' ? 'error' :
                                    'warning'
                                }
                                size="small"
                            />
                        </Box>
                    </ListItem>
                )
            })}
        </List>
    )
}

export default RecentDecisions
